import { Component, inject } from '@angular/core';
import { BTN_PRIMARY, BTN_SECONDARY, H1, SECTION_INNER } from '../../shared/ui';
import { RequestTermsNavigation, scrollToSection } from '../../shared/navigation';
import { PipelinePreviewComponent } from '../previews/pipeline-preview.component';

@Component({
  selector: 'app-hero-v3',
  standalone: true,
  imports: [PipelinePreviewComponent],
  templateUrl: './hero-v3.component.html',
})
export class HeroV3Component {
  private readonly requestTerms = inject(RequestTermsNavigation);

  readonly btnPrimary = BTN_PRIMARY;
  readonly btnSecondary = BTN_SECONDARY;
  readonly inner = SECTION_INNER;
  readonly h1 = H1;

  onRequestTerms(): void {
    this.requestTerms.go();
  }

  onExploreSolutions(): void {
    scrollToSection('solutions');
  }
}
